<template>
  <el-row>
    <el-col>
      <Filters
        class="mb-3"
        :resource="$sdk.asset_type"
        :filters.sync="filters"
        @apply="reload"
        @ready="load"
      />

      <el-card shadow="never">
        <ManufacturerType
          v-loading="loading"
          :data="types"
        >
          <template
            v-if="canUpdate || canDelete"
            v-slot:action="props"
          >
            <el-button
              v-if="canUpdate"
              size="mini"
              @click.native="$refs.actionForm.showEditForm(props.type)"
            >
              Edit
            </el-button>
            <el-button
              v-if="canDelete"
              size="mini"
              type="danger"
              @click.native="deleteType(props.type)"
            >
              Delete
            </el-button>
          </template>
        </ManufacturerType>
        <el-pagination
          class="text-center"
          :current-page.sync="types.page"
          :page-size.sync="types.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="types.total"
          @size-change="reload"
          @current-change="reload"
        />

        <CreateEditForm
          ref="actionForm"
          @save="save"
          @reload="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>

import ManufacturerType from '@/components/Application/Configuration/Assets/Type'
import Filters from '@/components/Filters/Complex'
import CreateEditForm from '@/components/Application/Configuration/Assets/Manufacturer/CreateEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'

export default {
  components: {
    ManufacturerType,
    CreateEditForm,
    Filters
  },
  data () {
    return {
      title: 'Types',
      breadcrumb: {
        name: 'Types',
        route: { name: 'configuration-assets-types' }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, this.$sdk.asset_type),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.$refs.actionForm.showCreateDialog()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.reload()
        }
      ],
      filters: [],
      types: [],
      loading: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, this.$sdk.asset_type)
    },
    canDelete () {
      return this.$user.can(DELETE, this.$sdk.asset_type)
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$sdk.asset_type.list(builder => {
        builder.filters = this.filters
      })
        .then(res => {
          this.types = res
        })
        .finally(() => { this.loading = false })
    },
    async reload () {
      this.loading = true
      try {
        await this.types.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('Failed to refresh Assets type\'slist')
      }
      this.loading = false
    },
    save (form) {
      this.$sdk.asset_type.create(
        {
          name: form.name,
          description: form.description
        },
        builder => {
        })
        .then(res => {
          this.$message({ message: 'Successfully saved', type: 'success' })
          this.reload()
        })
        .finally(() => {
          this.$refs.actionForm.closeDialog()
        })
    },
    deleteType (row) {
      this.$confirm('Are you sure to delete this asset\'s manufacturer ?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.loading = true
        row.delete()
          .then(res => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.reload())
      }).catch(() => {})
    }
  }
}
</script>
